(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/hooks/use-keno-xpress.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/hooks/use-keno-xpress.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = new svs.core.log.Logger('keno-xpress-leia');
const HostChannel = svs.ticketgames.ticketUtility.utils.HostChannel;
const _svs$kenoXpress$react = svs.kenoXpress.react.utils.wager,
  isWagerCompleted = _svs$kenoXpress$react.isWagerCompleted,
  getWagerId = _svs$kenoXpress$react.getWagerId,
  resetWagerId = _svs$kenoXpress$react.resetWagerId,
  getGameCodeByWager = _svs$kenoXpress$react.getGameCodeByWager;
const currencyFormatter = svs.ticketgames.ticketUtility.utils.currencyFormatter;
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useCallback = _React.useCallback,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.resultDialog,
  resultDialogNormal = _svs$ticketgames$tick.resultDialogNormal,
  resultDialogDemo = _svs$ticketgames$tick.resultDialogDemo;
const LOCAL_STORAGE_EXPIRATION_TIME = 15 * 60 * 1000;
const SESSION_EXPIRED_ERROR_CODE = 'BetError.40'; 

function sendAnalytics(transactionId, gameId, ticketPrice, ticketInfo) {
  let shouldHaveExtraData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
  if (ticketInfo) {
    const items = [];
    const productName = ticketInfo.name;
    const extraData = {
      gameType: ticketInfo.type
    };
    const trackingItem = new svs.components.analytics.transactionItem(gameId, ticketInfo.name,
    ticketPrice, 1, shouldHaveExtraData ? extraData : undefined);
    items.push(trackingItem);
    const transaction = new svs.components.analytics.transaction(transactionId, ticketPrice, items, 0, 0, undefined, capitalize(productName));
    svs.components.analytics.trackTransaction(transaction);
  }
}
const useKenoXpress = () => {
  const history = useHistory();
  const ref = useRef(null);
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAlreadyPayed = _useState4[0],
    setIsAlreadyPayed = _useState4[1];
  const _svs$kenoXpress$react2 = svs.kenoXpress.react.hooks.useLocalStorage('KENO_XPRESS.leia.state', {
      stake: 5,
      kungKeno: true,
      kenoNumbers: []
    }, LOCAL_STORAGE_EXPIRATION_TIME),
    _svs$kenoXpress$react3 = _slicedToArray(_svs$kenoXpress$react2, 2),
    gameState = _svs$kenoXpress$react3[0],
    setGameState = _svs$kenoXpress$react3[1];
  const _useState5 = useState(gameState),
    _useState6 = _slicedToArray(_useState5, 1),
    gameSpecificParameters = _useState6[0];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showPayment = _useState8[0],
    setShowPayment = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    gameUnavailable = _useState0[0],
    setGameUnavailable = _useState0[1];
  const ticketInfoName = 'KenoXpress';
  const onPrebet = useCallback(data => {
    const resolve = data.resolve,
      reject = data.reject,
      stake = data.stake,
      demo = data.demo;
    if (demo) {
      var _gameloaderHelper$ins;
      (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins = _gameloaderHelper$ins.bridgeFrame) === null || _gameloaderHelper$ins === void 0 || _gameloaderHelper$ins.focus();
      return resolve();
    }
    const obj = {
      productId: 'SKRKRY',
      betAmount: svs.utils.format.CurrencyFromJupiterString(currencyFormatter(stake.value)),
      productName: ticketInfoName,
      isTicket: true
    };
    svs.tur.wager.pay({
      cannotBeCancelled: true,
      wager: {},
      wagerprops: obj,
      success: () => {
        var _gameloaderHelper$ins2;
        (_gameloaderHelper$ins2 = gameloaderHelper.instance) === null || _gameloaderHelper$ins2 === void 0 || (_gameloaderHelper$ins2 = _gameloaderHelper$ins2.bridgeFrame) === null || _gameloaderHelper$ins2 === void 0 || _gameloaderHelper$ins2.focus();
        resolve();
      },
      abortCallback: () => {
        reject();
      },
      error: response => {
        reject();
        const isITSMessage = response.msg && response.msg.indexOf('ITS errorcode') > -1;
        svs.tur.apierrors.showErrorMessage({
          response: {
            error: {
              code: isITSMessage ? response.msg.split('errorcode: ')[1].replace(')', '') : response.rc
            }
          }
        });
        logger.error('LEIA Client error', response.request, response.rc, response.msg);
      }
    });
  }, []);
  const onBetDone = useCallback(bet => {
    const data = bet.data,
      betAmount = bet.betAmount,
      serviceName = bet.serviceName,
      demo = bet.demo;
    const ticketPrice = betAmount.value / 100;
    const ticketInfo = {
      name: ticketInfoName
    };
    if (!demo) {
      sendAnalytics(data.id, serviceName, ticketPrice, ticketInfo, false);
      svs.components.account_balance && svs.components.account_balance.get(true);
    }
    setShowPayment(false);
  }, []);
  const onClose = useCallback(() => {
    window.location.href = svs.core.urlMapping.get('kenoXpressHome');
  }, []);
  const onTag = useCallback(data => {
    var _data$viewInfo, _data$viewInfo2, _data$viewInfo3, _data$viewInfo4;
    if ((data === null || data === void 0 ? void 0 : data.eventType) === 'error' && (data === null || data === void 0 ? void 0 : data.event) === 'error') {
      setLoading(false);
    }
    if ((data === null || data === void 0 ? void 0 : data.eventType) === 'requestError' && (data === null || data === void 0 ? void 0 : data.event) === 'getMtrSession') {
      var _data$requestResponse, _data$requestResponse2;
      const gameSessionId = data === null || data === void 0 || (_data$requestResponse = data.requestResponse) === null || _data$requestResponse === void 0 || (_data$requestResponse = _data$requestResponse.data) === null || _data$requestResponse === void 0 || (_data$requestResponse = _data$requestResponse.context) === null || _data$requestResponse === void 0 ? void 0 : _data$requestResponse.gameSessionId;
      const errorCode = data === null || data === void 0 || (_data$requestResponse2 = data.requestResponse) === null || _data$requestResponse2 === void 0 || (_data$requestResponse2 = _data$requestResponse2.data) === null || _data$requestResponse2 === void 0 ? void 0 : _data$requestResponse2.code;
      if (errorCode === SESSION_EXPIRED_ERROR_CODE) {
        var _data$requestResponse3;
        logger.info("Tried to open game with unknown game session: ".concat(gameSessionId), JSON.stringify(data === null || data === void 0 || (_data$requestResponse3 = data.requestResponse) === null || _data$requestResponse3 === void 0 ? void 0 : _data$requestResponse3.data));
        const dialog = new svs.ui.dialog.Confirm({
          icon: 'exclamation-sign',
          branding: svs.ui.dialog.branding.TUR,
          type: svs.ui.dialog.type.ERROR,
          title: 'Hoppsan!',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: 'Vi kan inte visa ditt spel eftersom det inte avslutades korrekt.',
            align: svs.ui.dialog.message.align.CENTER
          }],
          allowDimmerClick: false,
          actions: [{
            title: 'Okej',
            callback: () => {
              onCloseDialog();
              dialog.close();
            }
          }]
        });
        svs.ui.dialog.api.add(dialog);
      } else {
        logger.info("could not retrieve MtrSession with id ".concat(gameSessionId), data);
      }
      setLoading(false);
    }
    if ((data === null || data === void 0 ? void 0 : data.eventType) === 'view' && (data === null || data === void 0 || (_data$viewInfo = data.viewInfo) === null || _data$viewInfo === void 0 ? void 0 : _data$viewInfo.name) === 'NumberPickerView' && (data === null || data === void 0 || (_data$viewInfo2 = data.viewInfo) === null || _data$viewInfo2 === void 0 ? void 0 : _data$viewInfo2.state) === 'willAppear') {
      setShowPayment(true);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    if ((data === null || data === void 0 ? void 0 : data.eventType) === 'view' && (data === null || data === void 0 || (_data$viewInfo3 = data.viewInfo) === null || _data$viewInfo3 === void 0 ? void 0 : _data$viewInfo3.name) === 'RevealView' && (data === null || data === void 0 || (_data$viewInfo4 = data.viewInfo) === null || _data$viewInfo4 === void 0 ? void 0 : _data$viewInfo4.state) === 'willAppear') {
      setShowPayment(false);
      setIsAlreadyPayed(false);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, []);
  const onCloseDialog = useCallback(() => {
    window.location.href = svs.core.urlMapping.get('kenoxpress_Related');
  }, []);
  const onPlayAgain = useCallback(() => {
    gameloaderHelper.instance.notifierProxy.sendNotification('playAgain');
    resetWagerId();
    history.push('/spela');
  }, [history]);
  const showResultDialog = useCallback(wonAmount => resultDialogNormal({
    wonAmount,
    onClose: onCloseDialog,
    onPlayAgain
  }), [onCloseDialog, onPlayAgain]);
  const showDemoDialog = useCallback(wonAmount => resultDialogDemo({
    wonAmount,
    onClose: onCloseDialog,
    onPlayAgain
  }), [onCloseDialog, onPlayAgain]);
  const showOngoingGameDialog = useCallback(data => {
    let message = 'Du har redan ett spel som du inte spelat klart. Gör det innan du spelar ett nytt.';
    let shouldResumeGame = true;
    if ((data === null || data === void 0 ? void 0 : data.state) === 'draw') {
      message = "Du har redan betalt f\xF6r detta spel ".concat(currencyFormatter(data.betAmount), " kr, du kan endast v\xE4lja nya nummer. Du kan ej \xE4ndra insats.");
      setIsAlreadyPayed(true);
      shouldResumeGame = false;
    } else if (getWagerId()) {
      gameloaderHelper.instance.notifierProxy.sendNotification('resumeGame');
      return;
    }
    const dialog = new svs.ui.dialog.Confirm({
      icon: 'exclamation-sign',
      branding: svs.ui.dialog.branding.TUR,
      title: 'Hoppsan!',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: message,
        align: svs.ui.dialog.message.align.CENTER
      }, {
        type: svs.ui.dialog.message.TEXT,
        text: 'Lycka till!',
        align: svs.ui.dialog.message.align.CENTER
      }],
      allowDimmerClick: false,
      actions: [{
        title: 'Okej',
        callback: () => {
          if (shouldResumeGame) {
            gameloaderHelper.instance.notifierProxy.sendNotification('resumeGame');
          }
          dialog.close();
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  }, []);
  const onSelectionChanged = useCallback(data => {
    setGameState(state => _objectSpread(_objectSpread({}, state), data));
  }, [setGameState]);
  const onStakeChanged = useCallback(data => {
    setGameState(state => _objectSpread(_objectSpread({}, state), data));
  }, [setGameState]);
  const onReplayFinished = useCallback(result => {
    var _result$wonAmount;
    if (((_result$wonAmount = result.wonAmount) === null || _result$wonAmount === void 0 ? void 0 : _result$wonAmount.value) > 0) {
      svs.tur.confettiCannon();
    }
  }, []);
  const onGameComplete = useCallback(result => {
    var _result$wonAmount2;
    if (result.demo) {
      showDemoDialog(result.wonAmount);
    } else {
      svs.components.account_balance && svs.components.account_balance.get(true);
      showResultDialog(result.wonAmount);
    }
    if (((_result$wonAmount2 = result.wonAmount) === null || _result$wonAmount2 === void 0 ? void 0 : _result$wonAmount2.value) > 0) {
      svs.tur.confettiCannon();
    }
  }, [showDemoDialog, showResultDialog]);
  const onGameLoaded = useCallback(() => {
    setLoading(false);
  }, []);
  const onCustomError = useCallback(data => {
    var _data$context, _data$message;
    let message;
    switch (data === null || data === void 0 ? void 0 : data.code) {
      case 'SESSION_STAKE_MISMATCH':
        message = "Insatsen m\xE5ste vara ".concat(currencyFormatter((_data$context = data.context) === null || _data$context === void 0 ? void 0 : _data$context.betAmount), " kr.");
        break;
      case 'INVALID_SESSION_GAME_TYPE':
        message = 'Du behöver spela klart ditt betalda spel innan du provspelar.';
        break;
      case 'INIT_STEP_FAILED':
        break;
      case 'DRW_STEP_FAILED':
      case 'INVALID_KENO_NUMBERS':
      case 'INVALID_STAKE_ERROR':
      case 'UNHANDLED_STATE':
      case 'INVALID_KENO_LEVEL':
      case 'UNKNOWN_ERROR':
      case 'STATE_CHANGE_ERROR':
      default:
        message = 'Ett oväntat fel har inträffat.';
    }
    logger.error("CUSTOM_ERROR - ".concat(data === null || data === void 0 ? void 0 : data.code, ": ").concat(data === null || data === void 0 || (_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.toString()));
    if (message) {
      const dialog = new svs.ui.dialog.Confirm({
        icon: 'exclamation-sign',
        branding: svs.ui.dialog.branding.TUR,
        title: 'Hoppsan!',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: message,
          align: svs.ui.dialog.message.align.CENTER
        }],
        allowDimmerClick: false,
        actions: [{
          title: 'Okej',
          callback: () => {
            dialog.close();
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    }
  }, []);
  const listener = useCallback((event, data) => {
    switch (event) {
      case 'GAME_LOADING':
      case 'DIMENSIONS':
        onGameLoaded();
        break;
      case 'HANDLE_PREBET':
        onPrebet(data);
        break;
      case 'HAS_BET':
        onBetDone(data);
        break;
      case 'CLOSE_GAME':
        onClose();
        break;
      case 'TAG':
        onTag(data);
        break;
      case 'REPLAY_FINISHED':
        onReplayFinished(data);
        break;
      case 'HAS_CLAIMED':
        onGameComplete(data);
        break;
      case 'HAS_ONGOING':
        showOngoingGameDialog(data);
        break;
      case 'SELECTION_CHANGED':
        onSelectionChanged(data);
        break;
      case 'STAKE_CHANGED':
        onStakeChanged(data);
        break;
      case 'CUSTOM_ERROR':
        onCustomError(data);
        break;
      default:
        break;
    }
  }, [onPrebet, onBetDone, onClose, onTag, onGameComplete, onReplayFinished, onGameLoaded, showOngoingGameDialog, onSelectionChanged, onStakeChanged, onCustomError]);
  const handleDemoGame = useCallback(() => {
    gameloaderHelper.instance.notifierProxy.sendNotification('performBet', 'DEMO');
  }, []);
  const handlePayGame = useCallback(() => {
    gameloaderHelper.instance.notifierProxy.sendNotification('performBet', 'NORMAL');
  }, []);
  useEffect(() => {
    var _svs$kenoXpress$data$, _svs$kenoXpress$data;
    const gameEngineCode = 'MTR';
    const gameCode = ((_svs$kenoXpress$data$ = svs.kenoXpress.data.gameConfig) === null || _svs$kenoXpress$data$ === void 0 ? void 0 : _svs$kenoXpress$data$.type) || getGameCodeByWager(); 
    const wagerId = isWagerCompleted() && getWagerId();
    const gameUnavailable = !((_svs$kenoXpress$data = svs.kenoXpress.data) !== null && _svs$kenoXpress$data !== void 0 && (_svs$kenoXpress$data = _svs$kenoXpress$data.gameConfig) !== null && _svs$kenoXpress$data !== void 0 && _svs$kenoXpress$data.open);
    if (!wagerId && gameUnavailable) {
      setGameUnavailable(true);
      setLoading(false);
      return;
    }
    const onDone = launchParams => {
      gameloaderHelper.openGame(_objectSpread(_objectSpread({}, launchParams), {}, {
        hostChannel: new HostChannel({
          type: gameEngineCode,
          name: gameCode,
          listener
        }),
        parentNode: ref.current
      }));
    };
    svs.ticketgames.ticketUtility.components.startGameByLoader({
      gameContext: {
        ticketInfo: svs.kenoXpress.data.gameConfig,
        isDemo: !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER),
        betId: wagerId && parseInt(wagerId, 10)
      },
      gameSpecificParameters,
      onDone
    });
    return () => {
      var _gameloaderHelper, _gameloaderHelper$clo;
      (_gameloaderHelper = gameloaderHelper) === null || _gameloaderHelper === void 0 || (_gameloaderHelper$clo = _gameloaderHelper.close) === null || _gameloaderHelper$clo === void 0 || _gameloaderHelper$clo.call(_gameloaderHelper);
    };
  }, [ref, listener, gameSpecificParameters]);
  return {
    ref,
    gameState,
    handleDemoGame,
    handlePayGame,
    onPlayAgain,
    showPayment,
    loading,
    isAlreadyPayed,
    gameUnavailable
  };
};
svs.kenoXpress.react.hooks.useKenoXpress = useKenoXpress;

 })(window);